/**
 * globalNav
 */

import $ from 'jquery';

// Module dependencies
import 'protons';
import './user-icon.png';

// Module styles
import './_global-nav.scss';

// Module template
import './_global-nav.twig';

export const name = 'globalNav';

export const defaults = {
  dummyClass: 'js-globalNav-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

export function enable($context) {
  // Find our component within the DOM
  const $globalNav = $('.global-nav', $context);
  // Bail if component does not exist
  if (!$globalNav.length) {
    return;
  }

  const $openNavButton = $globalNav.find('.global-nav__toggle');
  const $navWrapper = $globalNav.find('.global-nav__container');
  const $childNavToggle = $globalNav.find('.global-nav__nav-toggle');

  // Toggle nav open/close
  $openNavButton.on('click', () => {
    $navWrapper.toggleClass('menu-open');
    $('body').toggleClass('menu-open');
  });

  // Toggle nav child links open/close
  $childNavToggle.on('click', $childNavToggle, el => {
    const $plus = $(el.currentTarget);
    $plus
      .toggleClass('open')
      .siblings('ul')
      .slideToggle('fast');
    $plus.parent('li').toggleClass('section-open');
    el.preventDefault();
  });
}

export default enable;
